export const PAGE_EMPTY_STATE_LOAD_ERROR_RETRY_ACTION_NAME = 'retry'

export const QA_NAME_PAGE_EMPTY_STATE_LOAD_ERROR_RETRY =
  'pageEmptyStateLoadErrorRetry'
